import SendMessage from "../SendMessage/SendMessage";

const Footer = () => {
  return <SendMessage />;
};

export default Footer;
